<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>
        <div class="container pt-4">
            <h1 class="title">
                Texty
                <b-icon class="clickable" icon="plus-square-fill" variant="info"
                        @click="addNewItem()"></b-icon>
            
            </h1>
            
            <table class="table">
                <tbody>
                <tr v-for="item in posts.records" v-bind:key="item.id" v-bind:class="{ 'unavailable': item.available !== 1 }">
                    <td>
                        <h3 class="item-wrap" >
                            <div>{{item.name}}</div>
                            <div>
                                <b-icon class="clickable" icon="pencil-square" variant="info"
                                        @click="openModalEdit(item.id)"></b-icon>
                            </div>
                        </h3>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        
        
        <b-modal id="modal-texts-edit" class="modal" hide-header>
            <div class="d-block" v-if="modalData">
                <b-form-group>
                    <label>Obsah - {{modalData.name}}</label>
                    <text-editor v-model="modalData.content"
                                 type="text"
                                 @update="testUpdate()">
                        
                    </text-editor>
                </b-form-group>
            </div>
            
            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-texts-edit')">Zavřít</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import axios from 'axios'
import Navbar from "../components/navbar";
import MessageController from "../components/message-controller";
import TextEditor from "@/components/text-editor";

export default {
    name: "texts",
    components: {TextEditor, MessageController, Navbar},
    data() {
        return {
            posts: [],
            texts: [],
            modalData: Object,
            errors: [],
            changedModalId: null,
            newCommentLog: ''
        }
    },
    methods: {
        
        async loadData() {
            try {
                const response_data = await axios({
                    url: process.env.VUE_APP_SERVER+'texts/list.php',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    method: 'GET'
                });
                
                this.posts = response_data.data;
                
                if (this.changedModalId) {
                    this.changeDataInModal(this.changedModalId);
                }
                
                
            } catch (error) {
                console.log("error", error);
                this.$store.dispatch('logout');
            }
        },
        
        
        async updateModalData() {
            try {
                await axios({
                    url: process.env.VUE_APP_SERVER+'texts/update-item.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: this.modalData,
                    method: 'PUT'
                });
                //await this.loadData();
                //await this.$store.dispatch('loadDataTexts');
                this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');
                
            } catch (error) {
                await this.loadData();
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
            }
            
        },
        

        
        openModalEdit(itemId) {
            this.changedModalId = itemId;
            this.changeDataInModal(itemId);
            this.$bvModal.show('modal-texts-edit'); // open bs modal
            
            
            
        },
        changeDataInModal(itemId) {
            try {
                this.modalData = this.posts.records.find( ({ id }) => id === itemId );
            } catch(err) {
                console.log(err);
            }
        },
        testUpdate() {
            if (this.timeOut) clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
                this.updateModalData();
            }, 500);
        }
    },
    computed : {
        isEditable : function () { return (this.$route.params.action === 'edit' && this.$store.getters.isAdmin) },
    },
    created() {
        this.loadData();
    }
}
</script>

<style scoped lang="scss">
.table {
    max-width: 100%;
    th, td {
        padding-left: 0;
        padding-right: 0;
    }
}

h3.item-wrap {
    color: var(--cyan);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    
}
.description {
    color: #6c757d;
    line-height: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    
}

.icons {
    font-size: 1.5rem;
    float: right;
    cursor: pointer;
}

.badge {
    letter-spacing: .5px;
    font-weight: 500;
    vertical-align: middle;
}


.card-body {
    overflow: auto;
    max-height: 300px;
}


.title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.history_list {
    padding: 0;
    margin: 0;
    td {
        color: var(--gray);
        vertical-align: top;
        display: flex;
        flex-direction: column;
    }
    
    .table-date {
        white-space: nowrap;
    }
    
    &__row {
        width: 100%;
        flex: 1 0 100%;
        display: flex;
        justify-content: space-between;
    }
}
</style>
